import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { thead, tbody } from './table';

import './ProductList.scss';

export default class ProductList extends Component {
	static propTypes = {
		products: PropTypes.array.isRequired,
	};

	render() {
		return (
			<div className="ProductList">
				<table className="table table-bordered table-striped">
					{thead}
					{tbody(this.props.products)}
				</table>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ProductList/index.js